import dashboard from './dashboard';
import pages from './pages';
import utils from './utils';
import vehicle from './vehicle';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, vehicle, utils],
};

export default menuItems;
